module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba7bd42c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue2-google-maps/dist/components/streetViewPanorama.vue
// module id = 2846
// module chunks = 0